export const STC = 'stc' as const
export const STC_ADMIN = 'stcAdmin' as const
export const STC_LIST = 'stcList' as const
export const STC_ALL = 'stcAll' as const
export const STC_CREATE = 'stcCreate' as const
export const STC_DELETE = 'stcDelete' as const

export const STC_CATEGORY = 'stcCategory' as const
export const STC_CATEGORY_ALL = 'stcCategoryAll' as const
export const STC_CATEGORY_LIST = 'stcCategoryList' as const
export const STC_CATEGORY_CREATE = 'stcCategoryCreate' as const
export const STC_CATEGORY_DELETE = 'stcCategoryDelete' as const

export const STC_CHAPTER_DELETE = 'chapterDelete' as const
export const STC_CHAPTER_LIST = 'chapterList' as const
export const STC_CHAPTER_ALL = 'chapterAll' as const
export const STC_CHAPTER_CREATE = 'chapterCreate' as const
export const STC_CHAPTER_CREATE_BATCH = 'chapterCreateBatch' as const
export const STC_CHAPTER = 'chapter' as const

export const STC_STEP = `${STC}Step` as const
export const STC_STEP_ADMIN = `${STC}StepAdmin` as const
export const STC_STEP_LIST = `${STC_STEP}List` as const
export const STC_STEP_ADMIN_ALL = `${STC_STEP_ADMIN}All` as const
export const STC_STEP_ALL = `${STC_STEP}All` as const
export const STC_STEP_DELETE = `${STC_STEP}Delete` as const
export const STC_STEP_CREATE = `${STC_STEP}Create` as const
export const STC_STEP_COMPLETE = `${STC_STEP}Complete` as const

export const STC_TOPIC = `${STC}Topic` as const
export const STC_TOPIC_LIST = `${STC_TOPIC}List` as const
export const STC_TOPIC_ALL = `${STC_TOPIC}All` as const
export const STC_TOPIC_DELETE = `${STC_TOPIC}Delete` as const
export const STC_TOPIC_CREATE = `${STC_TOPIC}Create` as const

export const GLOBAL_STATE = 'ShortTermCourse' as const
